import { ChangeDetectorRef, Component, inject, OnInit, HostBinding, effect, DestroyRef } from "@angular/core";
import { Subscription } from "rxjs";
import { T1WestPanelComponent } from "../t1-west-panel";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { DashboardsService } from "@shared/index";
import { IDashboardModel } from "@app/views-interfaces/dashboard-model.interface";
import { ApplicationType, productStringFromApplicationType } from "@app/views-interfaces/ApplicationType.enum";
import { TranslateModule } from "@ngx-translate/core";
import { CardModalService } from "@shared/card-modal/card-modal.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "wk-west-panel",
    imports: [T1WestPanelComponent, JumpstartComponentsModule, TranslateModule],
    templateUrl: "./west-panel.component.html",
    styleUrl: "./west-panel.component.scss",
    host: { class: "wk-cm__west-panel" },
})
export class WestPanelComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);
    private readonly dashboardsService = inject(DashboardsService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    public readonly cardModalService = inject(CardModalService);

    currentDashboard: IDashboardModel;
    currentDashboardChangedSubscription: Subscription;
    isT1 = false;
    isPanelVisible = false;

    constructor() {
        effect(() => {
            const isCollapsed = this.cardModalService.isSidebarCollapsed();
            const tagGroup = document.getElementsByClassName("tags_body");
            if (tagGroup) this.cardModalService.totalTagsBodySpace.set(isCollapsed ? 540 : 440);
        });

        this.currentDashboardChangedSubscription = this.dashboardsService.currentDashboardChanged$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.init();
            });
    }

    ngOnInit() {
        this.init();
    }

    async init() {
        this.currentDashboard = await this.dashboardsService.getCurrentDashboard();
        this.isT1 = productStringFromApplicationType(this.currentDashboard.ApplicationType) === "T1";
        this.isPanelVisible = this.currentDashboard.ApplicationType !== ApplicationType.JobsBilling;
        if (!this.isPanelVisible) {
            this.cardModalService.isSidebarCollapsed.set(true);
            this.cardModalService.totalTagsBodySpace.set(585);
            this.cardModalService.saveSidebarSettingsToLocalStorage("collapsed");
        }
        this.changeDetectorRef.detectChanges();
    }

    public toggleSidebar() {
        const isCollapsed = this.cardModalService.isSidebarCollapsed();
        this.cardModalService.isSidebarCollapsed.set(!isCollapsed);
    }

    @HostBinding("class.wk-cm__west-panel--collapsed")
    get isCollapsed() {
        return this.cardModalService.isSidebarCollapsed();
    }
}
